import React from 'react';
import { ButtonType } from './type';
import { Loadabel } from '@/utils/index';
import { uiPrefix } from '@/constants';

const Button = Loadabel({
  loader: () => import(/* webpackChunkName: 'ui_button' */ './Button'),
  name: 'Button',
});

Button.defaultProps = {
    prefixCls: `${uiPrefix}-btn`
};
// React.lazy(() => import(/* webpackChunkName: 'ui_button' */ './Button')) as ButtonType;

export default Button;
